export default __webpack_public_path__ + "static/media/NHLPopupBg.1b249ffb.png";